<template>
  <div style="padding:50px 0px;">
    <div class="tab-pane pt-3 active show" v-if="ready">
      <!-- 商品種類 -->
      <div class="form-group row" id="radio">
        <div class="radio radio-inline ml-15">
          <input type="radio" id="category-all" v-model="category" value="">
          <label class="round button" for="category-all">[全部]</label>
        </div>
        <div class="radio radio-inline" v-for="(item, i) in coverageCategoryOption" :key="`coverage-kind-${i}`">
          <input type="radio" :id="`category-${i}`" v-model="category" :value="item.coveragecategoryid">
          <label class="round button" :for="`category-${i}`">{{item.name}}</label>
        </div>
      </div>
      <section class="row" :class="{'section-loading': isLoading}">
        <table class="table datatable">
          <thead>
            <tr>
              <th style="width:20%" class="text-center">保障項目編號</th>
              <th style="width:20%" class="text-center">保障項目說明</th>
              <th style="width:20%" class="text-center">保障項目歸類</th>
              <th style="width:20%" class="text-center">計算方法</th>
              <th style="width:10%" class="text-center">編輯</th>
              <th style="width:10%" class="text-center">刪除</th>
            </tr>
          </thead>
          <tbody v-if="coverageData.length">
            <tr v-for="(item, i) in coverageData" :key="`coverage-data-${i}`">
              <td>{{item.seq}}</td>
              <td>{{item.covergename}}</td>
              <td>{{item.cotegory}}</td>
              <td>{{item.methodname}}</td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-primary btn-sm"
                  @click="doEdit(item)"
                  >
                編輯
                </button>
              </td>
              <td class="text-center">
                <button
                  type="button"
                  class="btn btn-default btn-sm"
                  @click="deleteItem(item)"
                  >
                刪除
                </button>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td class="text-center" colspan="6">
                <h4 class="mb-3">查無資料</h4>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
    <div v-else>
      <message
        class="mt-5 d-flex justify-content-center"
        loading
        message="資料讀取中，請稍候..."
        />
    </div>
    <Coverage-Item-Add-Modal
      :open="coverageItemAddModalOpen"
      :coverageItemDetail="coverageItemDetail"
      :coverageCategoryOption="coverageCategoryOption"
      :isEdit="true"
      @close="closeCoverageItemAddModal"
      @cancel="panelClose('coverageItemAddModalOpen')"
      />
  </div>
</template>

<script>
import Message from "@/desktop/components/Message.vue";
import CoverageItemAddModal from "./components/CoverageItemAddModal";
import { commonMixin } from "@/mixins/common";
import {
  queryCoverageCategoryMain,
  queryCoverageCategory,
  getCoverageItemDetail,
  deleteCoverageItemDetail,
} from "@/service";
export default {
  name: "CoverageItemNameList",
  components: {
    Message,
    CoverageItemAddModal,
  },
  mixins: [commonMixin],
  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ready() {
      return !window._.isEmpty(this.coverageCategoryOption);
    },
  },
  data() {
    return {
      coverageData: [],
      coverageCategoryOption: [],
      coverageItemDetail: {},
      category: "",
      coverageItemAddModalOpen: false,
      isLoading: false,
    };
  },
  watch: {
    category() {
      this.queryCoverageCategory();
    },
    reload(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    async init() {
      await this.getCategoryOption();
      this.queryCoverageCategory();
    },
    async getCategoryOption() {
      const res = await queryCoverageCategoryMain(
        this.$store.state.userInfo.id
      );
      this.coverageCategoryOption = res.data;
    },
    queryCoverageCategory() {
      this.isLoading = true;
      queryCoverageCategory(this.$store.state.userInfo.id, this.category).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.coverageData = result.data;
          } else {
            this.coverageData = [];
          }
          this.isLoading = false;
        }
      );
    },
    deleteItem(data) {
      if (confirm("確認刪除此筆保障項目？")) {
        this.isLoading = true;
        deleteCoverageItemDetail(this.$store.state.userInfo.id, data).then(
          (result) => {
            if (result.header && result.header.status == "200") {
              this.$toast.info({ title: "刪除成功" });
              this.queryCoverageCategory();
            } else {
              this.$toast.info({ title: result.header.message });
            }
            this.isLoading = false;
          }
        );
      }
    },
    doEdit(data) {
      getCoverageItemDetail(this.$store.state.userInfo.id, data).then(
        (result) => {
          if (result.header && result.header.status == "200") {
            this.coverageItemDetail = result.data;
            this.panelOpen("coverageItemAddModalOpen");
          } else {
            this.$toast.info({ title: result.header.message });
          }
        }
      );
    },
    closeCoverageItemAddModal() {
      this.panelClose("coverageItemAddModalOpen");
      this.queryCoverageCategory();
    },
  },
  mounted() {
    this.init();
  },
};
</script>
<style scoped>
#radio .radio input + label:before,
#radio .radio input:checked + label:after {
  display: none !important;
}
#radio .radio {
  margin-right: 0px;
}
#radio input:checked + .button {
  background: #fef3e7;
  color: #f58818;
  border: 1px solid #f58818;
  cursor: default;
}
#radio .button {
  display: inline-block;
  margin: 0 5px 10px 0;
  padding: 5px 10px;
  background: #f7f7f7;
  color: #333;
  cursor: pointer;
}
#radio .button:hover {
  background: #fef3e7;
  color: #f58818;
  border: 1px solid #f58818;
  border-radius: 4px;
}
#radio .round {
  border-radius: 5px;
}
</style>
